import { Tooltip } from 'react-tooltip';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import { keyBy, mapValues, round } from 'lodash';

import useBusinessUnitsQuery from 'shared/api/business-units/useBusinessUnitsQuery';
import { formatArea, formatNumeric } from 'utils/format';
import styles from 'theme/features/dashboard/dashboard-site-wide.module.scss';

const ProgramSummary = ({ breakdown, measurementSystem }) => {
  const { data: businessUnits } = useBusinessUnitsQuery();

  const businessUnitNameById = mapValues(keyBy(businessUnits, 'id'), (value) => value.name);

  return (
    <section className={styles['program-summary']}>
      <h4>
        <strong>Program Summary</strong>
      </h4>
      <br />
      <Table size="sm">
        <TableHead>
          <TableRow>
            <TableHeader>Business Unit</TableHeader>
            <TableHeader>Headcount</TableHeader>
            <TableHeader>Attending Population</TableHeader>
            <TableHeader>Attendance Rate</TableHeader>
            <TableHeader>Workstation Quant.</TableHeader>
            <TableHeader>
              BU Specialty and <br /> Site Specific Space Area
            </TableHeader>
            <TableHeader>Project Total Area</TableHeader>
            <TableHeader>
              Percentage Overall{' '}
              <button
                className={styles.tooltip}
                type="button"
                data-tooltip-id="percentage-overall-tooltip"
                data-tooltip-place="bottom"
                data-tooltip-position-strategy="fixed"
              >
                <Information />
              </button>
              <Tooltip id="percentage-overall-tooltip" style={{ maxWidth: 240 }}>
                Percentage Overall includes BU Specialty and Site Specific Spaces
              </Tooltip>
            </TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {breakdown
            ?.filter((b) => b.headcount || b.total.area)
            .map((row, index) => (
              <TableRow key={index}>
                <TableCell>{businessUnitNameById[row.id]}</TableCell>
                <TableCell>{formatNumeric(row.headcount)}</TableCell>
                <TableCell>{formatNumeric(row.attendance)}</TableCell>
                <TableCell>{formatNumeric(row.attendanceRate)}%</TableCell>
                <TableCell>{formatNumeric(row.individualWorkstations.quantity)}</TableCell>
                <TableCell>{formatArea(row.specialty.area + row.siteSpecific.area, measurementSystem)}</TableCell>
                <TableCell>{formatArea(row.total.area, measurementSystem)}</TableCell>
                <TableCell>{formatNumeric(round(row.total.overallPercentage, 1))}%</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </section>
  );
};

export default ProgramSummary;
